import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import Framework from "@beardeddevops/react.framework";

class SidebarContent extends React.Component {

	render() {
		const {rootState} = this.props;

		return (
			<>
				<li>
					<Link variant={"text"} to={`/forms/computer_repair_waiver`}>
						<span className="nav-text">Computer Repair Waiver</span>
					</Link>
				</li>

				<li>
					<Link variant={"text"} to="/forms/refund_agreement">
						<span className="nav-text">Refund Agreement</span>
					</Link>
					<ul style={{display: 'block'}}>
					</ul>
				</li>

				<li>
					<Link variant={"text"} to="/forms/completion_certificate">
						<span className="nav-text">Completion Certificate</span>
					</Link>
					<ul style={{display: 'block'}}>
					</ul>
				</li>

				<li>
					<Link variant={"text"} to="/forms/data_backup_waiver">
						<span className="nav-text">Data Backup Waiver</span>
					</Link>
					<ul style={{display: 'block'}}>

					</ul>
				</li>

				<li>
					<Link variant={"text"} to="/forms/hard_drive_inspection_waiver">
						<span className="nav-text">Hard Drive Inspection Waiver</span>
					</Link>
					<ul style={{display: 'block'}}>
					</ul>
				</li>

				<li>
					<Link variant={"text"} to="/forms/anti_virus_inspection_waiver">
						<span className="nav-text">Anti Virus Inspection Waiver</span>
					</Link>
					<ul style={{display: 'block'}}>
					</ul>
				</li>

				<li>
					<Link variant={"text"} to="/forms/network_inspection_waiver">
						<span className="nav-text">Network Inspection Waiver</span>
					</Link>
					<ul style={{display: 'block'}}>
					</ul>
				</li>

			</>
		);
	}
}

export default Framework.Components.withRootState(withRouter(SidebarContent));
